import { Outlet } from "react-router-dom";

const PropertyRoot = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default PropertyRoot;
